const createLink = (data) => {
  // if (true) return data;
  // Check if the text includes square brackets
  const hasBrackets = /\[.*\]\((.*)\)/.test(data);

  if (hasBrackets) {
    // Extract the name and URL from the text inside the brackets
    const [name, url] = data.match(/\[.*\]\((.*)\)/)[1].split("](");
    // const abcData = data.match(/\[.*\]\((.*)\)/)[1].split("](");
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {name}
      </a>
    );
  } else {
    // Return plain text if no square brackets are found
    return data;
  }
};

export default createLink;

// Function to check if a string contains all the required words
export function containsAllPhrases(inputString, requiredPhrases) {
  // Check if every phrase is present in the input string
  return requiredPhrases.every((phrase) => inputString.includes(phrase));
}

export function containsAgentDetails(inputString) {
  // List of required phrases
  const agentDetails = ["Agent Name:", "Address:", "Phone Number:"];
  return containsAllPhrases(inputString, agentDetails);
}

// Function to parse the input string and extract details into an object
// export function parseAgentDetails(inputString) {
//   const details = {};

//   // Normalize input by replacing all backslashes with newlines for uniform parsing
//   const normalizedInput = inputString.replace(/\\/g, "\n");

//   // Extract Agent Name
//   const nameMatch = normalizedInput.match(/\*\*Agent Name:\*\*\s*(.*?)\n/);
//   details.name = nameMatch ? nameMatch[1] : "";

//   // Extract Address
//   const addressMatch = normalizedInput.match(/\*\*Address:\*\*\s*(.*?)\n/);
//   details.address = addressMatch ? addressMatch[1] : "";

//   // Extract Phone Number
//   const phoneMatch = normalizedInput.match(
//     /\*\*Phone Number:\*\*\s*\[(.*?)\]\(tel:.+?\)/
//   );
//   details.phone = phoneMatch ? phoneMatch[1] : "";
//   return details;
// }

export function isJSONObject(data) {
  try {
    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (data && typeof data === "object") {
      return true;
    }
    let updatedData = data.replaceAll("'", '"');
    let o = JSON.parse(updatedData);
    if (o && typeof o === "object") {
      return true;
    }
  } catch (e) {
    console.log("ERROR in parsing response to JSON");
  }

  return false;
}

export function parseAgentDetails(data) {
  if (data && typeof data === "object") {
    return data;
  }
  let updatedData = data.replaceAll("'", '"');
  let o = JSON.parse(updatedData);
  if (o && typeof o === "object") {
    return o;
  }
}
